import React from "react"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import RadioUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked"
import RadioCheckedIcon from "@material-ui/icons/RadioButtonChecked"
import useStyles from "./styles"

const UserAccordion = ({
  groupKey,
  groupName,
  users,
  selected,
  allSelected,
  expanded,
  handleExpand,
  handleCheck,
  handleSelectAll
}) => {
  const classes = useStyles()

  return (
    <Accordion
      expanded={expanded === groupName}
      onChange={handleExpand(groupName)}
    >
      <AccordionSummary
        className={classes.accordionSummary}
        expandIcon={<ExpandMoreIcon color="primary" />}
      >
        <Typography>
          {groupName}{" "}
          <span className={classes.usersSelected}>
            {selected.length ? selected.length : ""}
          </span>
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>
        <Table className={classes.table} size="small">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell align="right">
                <Button
                  className={classes.selectAllButton}
                  variant="text"
                  onClick={handleSelectAll(groupKey)}
                >
                  {allSelected ? "Deselect all" : "Select all"}
                </Button>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users &&
              users.length &&
              users.map(row => (
                <TableRow key={row.id} className={classes.tableRow}>
                  <TableCell component="th" scope="row">
                    {row.name}
                  </TableCell>
                  <TableCell align="right">
                    <Checkbox
                      className={classes.checkbox}
                      size="small"
                      icon={<RadioUncheckedIcon />}
                      checkedIcon={<RadioCheckedIcon />}
                      color="primary"
                      checked={selected.indexOf(row.id) !== -1}
                      onChange={handleCheck(groupKey, row.id)}
                    />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </AccordionDetails>
    </Accordion>
  )
}

export default UserAccordion



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/CommunicationText/CommunicationTextAccordion/UserAccordion/index.jsx